import React, { FC } from 'react';
import MuiFade, { FadeProps as MuiFadeProps } from '@mui/material/Fade';
import { BpDesignSystem } from '../../types';

export type FadeProps = BpDesignSystem.PropsWithChildren<MuiFadeProps & {}>;

export const Fade: FC<FadeProps> = ({ dataTest, ...props }) => <MuiFade data-test={dataTest} {...props} />;
